import React, { useEffect, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import jMoment from "moment-jalaali";
import { Edit } from "@material-ui/icons";
import BaseInfoForm from "../../../components/baseInfoForm/BaseInfoForm";
import { useFetch } from "../../../features/customHooks/useFetch";
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

const useStyles = makeStyles((theme) => ({
  title: { fontWeight: "bold", fontSize: 15 },
  value: { fontSize: 15, marginLeft: 5 },
}));

const BaseInfo = (props) => {
  const classes = useStyles();
  const { data } = props;
  const { loading = true, valuation = [], regetValuation } = data;

  const baseInfoRef = useRef(null);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleOpenDialog = () => setEditDialogOpen(true);
  const handleCloseDialog = () => setEditDialogOpen(false);

  const [updateFetchState, setUpdateFetchParams] = useFetch();

  const onSubmitForm = (data, event) => {
    const params = {
      method: "put",
      url: "/valuation/" + valuation?.id,
      data: data,
    };
    setUpdateFetchParams(params);
  };

  useEffect(() => {
    if (!updateFetchState.loading && !updateFetchState.error && updateFetchState.data) {
      handleCloseDialog();
      regetValuation();
    }

    if (!updateFetchState.loading && updateFetchState.error) {
      console.log("error");
    }
  }, [updateFetchState]);

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          اطلاعات پایه
        </Typography>

        <div style={{ flexGrow: 1 }} />

        {valuation?.can_edit && (
          <Tooltip title='ویرایش' onClick={handleOpenDialog}>
            <IconButton>
              <Edit />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      {loading ? (
        <Grid container alignItems='center' justifyContent='center'>
          <CircularProgress style={{ color: "#757575" }} />
        </Grid>
      ) : (
        <Grid container direction='row'>
          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>شناسه:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.id?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>شناسه کل:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.full_id?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>گزارش از:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.from?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>تاریخ گزارش:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {jMoment(valuation?.date ?? "")
                  .format("jYYYY/jMM/jDD")
                  ?.toString()
                  ?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>نوع گزارش:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.type?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>واقع در شهر:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.city?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Grid
              container
              direction='row'
              justifyContent='flex-start'
              alignItems='center'
              style={{ marginTop: 15 }}
              wrap='nowrap'
            >
              <Typography className={classes.title}>آدرس:</Typography>

              <Typography color='textSecondary' className={classes.value} noWrap>
                {valuation?.address?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>کد پستی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.postal_code?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>پلاک(های) ثبتی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.plate?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>قطعه:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.piece?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>نوع سازه ساختمانی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.structure_type?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {valuation?.can_edit && (
        <Dialog open={editDialogOpen} maxWidth={"md"} fullWidth>
          <DialogTitle>ویرایش اطلاعات پایه</DialogTitle>
          <DialogContent>
            <BaseInfoForm
              ref={baseInfoRef}
              onSubmitForm={onSubmitForm}
              defaultValues={{
                from: valuation?.from,
                date: valuation?.date,
                type: valuation?.type,
                city: valuation?.city,
                address: valuation?.address,
                postal_code: valuation?.postal_code,
                plate: valuation?.plate,
                piece: valuation?.piece,
                structure_type: valuation?.structure_type,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>لغو</Button>
            <Button variant='contained' color='primary' onClick={() => baseInfoRef.current.submit()}>
              {updateFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "ویرایش"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Paper>
  );
};

export default BaseInfo;
